import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { UdsRentalForm } from '../models/ci-form.model';
import { CiCalculationResult } from '../../../_services/ci.service';
import { UiCalculatedBoxComponent } from '../ui/ui-calculated-box.component';
import { UiInputComponent } from '../ui/ui-input.component';
import { formatCompactCurrency, formatPct, formatPsf } from '../../../core/utils/format.util';

/**
 * Every derived figure here comes from the backend calculation result; while
 * no result exists yet the boxes show a dash.
 */
@Component({
  selector: 'ci-step-uds-rental',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, UiInputComponent, UiCalculatedBoxComponent],
  templateUrl: './step-uds-rental.component.html',
})
export class StepUdsRentalComponent {
  readonly form = input.required<UdsRentalForm>();
  readonly result = input<CiCalculationResult | null>(null);

  psf = formatPsf;

  adjustedUdsValue(): string {
    const value = this.result()?.adjustedCurrentValueOfUds;
    return value != null ? formatCompactCurrency(value) : '—';
  }

  udsSupportPct(): string {
    const pct = this.result()?.udsSupportPercent;
    return pct != null ? formatPct(pct * 100, 1) : '—';
  }

  annualRent(): string {
    const value = this.result()?.averageRentPa;
    return value != null ? formatCompactCurrency(value) : '—';
  }

  rentalYieldPct(): string {
    const pct = this.result()?.rentalYield;
    return pct != null ? formatPct(pct * 100, 1) : '—';
  }
}
